import { css } from 'emotion';
import * as React from 'react';

import AnchorLogoIcon from './components/AnchorLogoIcon';
import AnchorPayIcon from './components/AnchorPayIcon';
import AppleLogoIcon from './components/AppleLogoIcon';
import ArrowIcon from './components/ArrowIcon';
import CheckmarkIcon from './components/CheckmarkIcon';
import CircularArrowIcon from './components/CircularArrowIcon';
import ClockIcon from './components/ClockIcon';
import DistributionNetworkIcon from './components/DistributionNetworkIcon';
import DollarSignIcon from './components/DollarSignIcon';
import DownloadIcon from './components/DownloadIcon';
import { EpisodeDetailsIcon } from './components/EpisodeDetailsIcon';
import { EpisodeFailedToLoadIcon } from './components/EpisodeFailedToLoadIcon';
import EpisodeIcon from './components/EpisodeIcon';
import ExternalLinkIcon from './components/ExternalLinkIcon';
import EyeDropperIcon from './components/EyeDropperIcon';
import { GearIcon } from './components/GearIcon';
import GooglePlayLogoIcon from './components/GooglePlayLogoIcon';
import JustifiedIcon from './components/JustifiedIcon';
import { LinkIcon } from './components/LinkIcon';
import LockIcon from './components/LockIcon';
import MagnifyingGlassIcon from './components/MagnifyingGlassIcon';
import MicrophoneIcon from './components/MicrophoneIcon';
import OptionDotsIcon from './components/OptionDotsIcon';
import PauseIcon from './components/PauseIcon';
import PlayIcon from './components/PlayIcon';
import PodcastIcon from './components/PodcastIcon';
import { PowerIcon } from './components/PowerIcon';
import QuestionMarkIcon from './components/QuestionMarkIcon';
import QuoteIcon from './components/QuoteIcon';
import RedirectionIcon from './components/RedirectionIcon';
import ReRecordIcon from './components/ReRecordIcon';
import TrashIcon from './components/TrashIcon';
import UpsidedownTriangleIcon from './components/UpsidedownTriangleIcon';
import UpwardTrendingGraphIcon from './components/UpwardTrendingGraphIcon';
import XIcon from './components/XIcon';

import { IconProps, IconType } from './index.d';

// To change the size of the icon: change the width of the container element.
const renderIconForType = (
  type: IconType,
  svgClassName: string,
  fillColor: string,
  isInCircle: boolean,
  circleColor: string
): React.ReactNode => {
  switch (type) {
    case 'gear':
      return <GearIcon className={svgClassName} fillColor={fillColor} />;
    case 'power':
      return <PowerIcon className={svgClassName} fillColor={fillColor} />;
    case 'clock':
      return (
        <ClockIcon
          isInCircle={isInCircle}
          circleColor={circleColor}
          className={svgClassName}
          fillColor={fillColor}
        />
      );
    case 'lock':
      return (
        <LockIcon
          isInCircle={isInCircle}
          circleColor={circleColor}
          className={svgClassName}
          fillColor={fillColor}
        />
      );
    case 'redirection':
      return <RedirectionIcon className={svgClassName} fillColor={fillColor} />;
    case 'distributionNetwork':
      return (
        <DistributionNetworkIcon
          className={svgClassName}
          fillColor={fillColor}
        />
      );
    case 'episode':
      return <EpisodeIcon className={svgClassName} fillColor={fillColor} />;
    case 'EpisodeFailedToLoad':
      return (
        <EpisodeFailedToLoadIcon
          className={svgClassName}
          fillColor={fillColor}
        />
      );
    case 'EpisodeDetails':
      return (
        <EpisodeDetailsIcon className={svgClassName} fillColor={fillColor} />
      );
    case 'upwardTrendingGraph':
      return (
        <UpwardTrendingGraphIcon
          className={svgClassName}
          fillColor={fillColor}
        />
      );
    case 'podcast':
      return <PodcastIcon className={svgClassName} fillColor={fillColor} />;
    case 'apple_logo':
      return <AppleLogoIcon className={svgClassName} fillColor={fillColor} />;
    case 'google_play_logo':
      return (
        <GooglePlayLogoIcon className={svgClassName} fillColor={fillColor} />
      );
    case 're_record':
      return <ReRecordIcon className={svgClassName} fillColor={fillColor} />;
    case 'trash':
      return <TrashIcon className={svgClassName} fillColor={fillColor} />;
    case 'circular_arrow':
      return (
        <CircularArrowIcon className={svgClassName} fillColor={fillColor} />
      );
    case 'question_mark':
      return (
        <QuestionMarkIcon className={svgClassName} fillColor={fillColor} />
      );
    case 'dollar_sign':
      return <DollarSignIcon className={svgClassName} fillColor={fillColor} />;
    case 'option_dots':
      return <OptionDotsIcon className={svgClassName} fillColor={fillColor} />;
    case 'microphone':
      return <MicrophoneIcon className={svgClassName} fillColor={fillColor} />;
    case 'anchor_pay':
      return <AnchorPayIcon className={svgClassName} fillColor={fillColor} />;
    case 'external_link':
      return (
        <ExternalLinkIcon className={svgClassName} fillColor={fillColor} />
      );
    case 'play':
      return <PlayIcon className={svgClassName} fillColor={fillColor} />;
    case 'upsidedown_triangle':
      return (
        <UpsidedownTriangleIcon
          className={svgClassName}
          fillColor={fillColor}
        />
      );
    case 'quote':
      return <QuoteIcon className={svgClassName} fillColor={fillColor} />;
    case 'pause':
      return <PauseIcon className={svgClassName} fillColor={fillColor} />;
    case 'download':
      return <DownloadIcon className={svgClassName} fillColor={fillColor} />;
    case 'x':
      return <XIcon className={svgClassName} fillColor={fillColor} />;
    case 'checkmark':
      return <CheckmarkIcon className={svgClassName} fillColor={fillColor} />;
    case 'anchor_logo':
      return <AnchorLogoIcon className={svgClassName} fillColor={fillColor} />;
    case 'eye_dropper':
      return <EyeDropperIcon className={svgClassName} fillColor={fillColor} />;
    case 'left_arrow':
      return (
        <ArrowIcon
          className={svgClassName}
          direction="left"
          fillColor={fillColor}
        />
      );
    case 'magnifying_glass':
      return (
        <MagnifyingGlassIcon className={svgClassName} fillColor={fillColor} />
      );
    case 'justified_center':
      return (
        <JustifiedIcon
          type="center"
          className={svgClassName}
          fillColor={fillColor}
        />
      );
    case 'justified_left':
      return (
        <JustifiedIcon
          type="left"
          className={svgClassName}
          fillColor={fillColor}
        />
      );
    case 'justified_right':
      return (
        <JustifiedIcon
          type="right"
          className={svgClassName}
          fillColor={fillColor}
        />
      );
    case 'link':
      return <LinkIcon className={svgClassName} fillColor={fillColor} />;
    case 'none':
      return null;
    default:
      const exhaustiveCheck: never = type;
      return exhaustiveCheck;
  }
};

const containerClassName = css({
  width: '100%',
});

const svgClassName = css({
  display: 'block',
  margin: 'auto',
});

const defaultProps = {
  fillColor: '#53585E',
  isInCircle: false,
  circleColor: 'black',
};

const Icon = ({
  type,
  fillColor,
  isInCircle,
  circleColor,
}: IconProps): React.ReactElement<React.ReactNode> => (
  <div className={containerClassName}>
    {renderIconForType(type, svgClassName, fillColor, isInCircle, circleColor)}
  </div>
);

Icon.defaultProps = defaultProps;

export { Icon as default, Icon };
